module.exports = __webpack_public_path__ + "static/img/5-2.c5827296.png";